import React from 'react'

import {ConfirmHighlight} from './BookingsPortalPage.styled'

import {Container} from '~/components/general/container/Container'
import {Typography} from '~/components/general/typography/Typography'
import {Button} from '~/components/general/button/Button'
import {Modal} from '~/components/general/modal/Modal'

type ConfirmBookingModalProps = {
  isVisible: boolean
  onClose: () => void
  onCancel: () => void
  onConfirm: () => void
  isLoading: boolean
  header: string
  bodyIntro: string
  partnerServiceName?: string
  nameLine: string
  dateTimeLine: string
  email: string
  phone?: string
  cancelLabel: string
  confirmLabel: string
  timeZoneNotice?: string
}

export const ConfirmBookingModal: React.FC<ConfirmBookingModalProps> = ({
  isVisible,
  onClose,
  onCancel,
  onConfirm,
  isLoading,
  header,
  bodyIntro,
  partnerServiceName,
  nameLine,
  dateTimeLine,
  email,
  phone,
  cancelLabel,
  confirmLabel,
  timeZoneNotice,
}) => (
  <Modal
    header={header}
    footer={
      <Container flex justify="space-between" align="center">
        <Button color="primary" onClick={onCancel} disabled={isLoading}>
          {cancelLabel}
        </Button>
        <Button color="secondary" onClick={onConfirm} disabled={isLoading}>
          {confirmLabel}
        </Button>
      </Container>
    }
    isVisible={isVisible}
    onClose={onClose}>
    <Container direction="column" spacing={1}>
      <Typography>{bodyIntro}</Typography>
      <ConfirmHighlight>
        <Typography weight="bold">{partnerServiceName || '—'}</Typography>
        <Typography weight="bold">{nameLine}</Typography>
        <Typography weight="bold">{dateTimeLine}</Typography>
        <Typography weight="bold">{email || '—'}</Typography>
        {phone ? <Typography weight="bold">{phone}</Typography> : null}
      </ConfirmHighlight>
      {timeZoneNotice && (
        <Typography size="sm" color="muted">
          {timeZoneNotice}
        </Typography>
      )}
    </Container>
  </Modal>
)
